export const FormatNumberService = Symbol.for('FormatNumberService');
